/* marca-3 (C.1 y C.2, #736): EL AVISO "StudyBuddy ahora es Quizessa", durante 30 dias.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Se pinta mientras la fecha de HOY en la Ciudad de Mexico sea menor que AVISO_MARCA_HASTA; despues
   desaparece solo, sin despliegue. La MISMA literal vive en backend/config.py (la usa el correo de
   bienvenida) y `scripts/aviso_marca.test.js` lee los dos archivos y falla si difieren.

   La "x" lo cierra y se recuerda en ese aparato (`sb_aviso_marca_cerrado`); si el almacen no se deja
   leer o escribir, se cierra solo en esta sesion. Lo usan el renglon del Panel (AvisoMudanza.js,
   variante "marca") y la tira de la portada (LandingPage.js). */
import { useCallback, useState } from 'react';

export const AVISO_MARCA_HASTA = '2026-11-26';
export const LLAVE_CERRADO = 'sb_aviso_marca_cerrado';
export const LLAVE_TEXTO = 'common:aviso_marca';
export const LLAVE_CERRAR = 'common:close';

export function hoyEnMexico(ahora = new Date()) {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit',
    }).format(ahora);
  } catch {
    // Sin la base de zonas: Mexico no tiene horario de verano desde 2022, UTC-6 fijo.
    return new Date(ahora.getTime() - 6 * 3600 * 1000).toISOString().slice(0, 10);
  }
}

export function avisoMarcaVigente(ahora = new Date()) {
  return hoyEnMexico(ahora) < AVISO_MARCA_HASTA;
}

export function leerCerrado() {
  try {
    return window.localStorage.getItem(LLAVE_CERRADO) === '1';
  } catch {
    return false;
  }
}

export function guardarCerrado() {
  try {
    window.localStorage.setItem(LLAVE_CERRADO, '1');
  } catch {
    // sin almacen: se cierra solo en esta sesion
  }
}

export function useAvisoMarca() {
  const [cerrado, setCerrado] = useState(() => leerCerrado());
  const cerrar = useCallback(() => {
    guardarCerrado();
    setCerrado(true);
  }, []);
  return { mostrar: !cerrado && avisoMarcaVigente(), cerrar };
}
